import Api from './Api';

const all = (payload) => {
    const path = '/get-migrate-data';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const store = (payload) => {
    return Api.postRequest({
        endpoint: '/migrate-invoice',
        data: payload
    });
};

const update = (payload) => {
    return Api.postRequest({
        endpoint: '/invoice/update',
        method: 'PUT',
        data: payload
    });
};

const destroy = (payload) => {
    return Api.deleteRequest({
        endpoint: `/invoice/destroy/${payload.id}`,
    });
};

export default {
    all,
    store,
    update,
    destroy
};
